module.exports = __webpack_public_path__ + "static/14.1920x1080_JB_SpiderVerse_Interview_30_181128-4dced0e3ede7a47ed5c37d633c422784.mp4";